import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setTopPerformingNetworkAction } from "@oldDashboard/legacyActions/dashboardClient";

const useTopPerformingNetwork = (affiliateSelected: any, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, searching: boolean) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchTopPerformingNetwork();
    }, [searching, launchSelected]);
    

    const fetchTopPerformingNetwork = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getTopPerformingNetwork(affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate);
            if(response.success)
                setTopPerformingNetworkAction(response.chart_data.data);
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
     
    }
    return { isLoading, fetchTopPerformingNetwork }
}

export default useTopPerformingNetwork